import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { EmojiIcon } from '../EmojiIcon';
import styles from './QuestionSmellsSlideV1.css';

const cx = classnames.bind(styles);

function toggle(list, index) {
    return list.includes(index) ? list.filter(item => item !== index) : [...list, index];
}

function QuestionSmellsSlideV1({ id, question, hint, groups, spriteVersion, submitTemporaryAnswer, userResponse = {} }) {
    const [picked, setPicked] = useState({ good: userResponse?.good || [], bad: userResponse?.bad || [] });

    useEffect(() => {
        const text = groups
            .flatMap(group => picked[group.key].map(index => group.items[index].text))
            .join(', ');

        submitTemporaryAnswer({ id: 1, questionId: id, question, text, good: picked.good, bad: picked.bad });
    }, [picked]);

    const handleToggle = (key, index) => () => setPicked(prev => ({ ...prev, [key]: toggle(prev[key], index) }));

    return (
        <div className={styles.form} key={id}>
            <div className={styles.text}>
                <h1 className={styles.question}>{question}</h1>
                <p className={styles.hint}>{hint}</p>
            </div>
            <div className={styles.groups}>
                {groups.map(group => (
                    <section className={styles.group} key={group.key}>
                        <h2 className={styles.groupTitle}>
                            <EmojiIcon name={group.icon} version={spriteVersion} />
                            {group.title}
                        </h2>
                        <ul className={styles.chips}>
                            {group.items.map((item, index) => {
                                const isChecked = picked[group.key].includes(index);

                                return (
                                    <li key={item.text}>
                                        <button
                                            type='button'
                                            className={cx('chip', { checked: isChecked })}
                                            onClick={handleToggle(group.key, index)}
                                            aria-pressed={isChecked}
                                        >
                                            <EmojiIcon name={item.icon} version={spriteVersion} />
                                            {item.text}
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>
                    </section>
                ))}
            </div>
        </div>
    );
}

QuestionSmellsSlideV1.propTypes = {
    id: PropTypes.number.isRequired,
    question: PropTypes.string.isRequired,
    hint: PropTypes.string,
    groups: PropTypes.array.isRequired,
    spriteVersion: PropTypes.string.isRequired,
    submitTemporaryAnswer: PropTypes.func.isRequired,
    userResponse: PropTypes.object
};

export {
    QuestionSmellsSlideV1
};
